export const MOBILE_REGEX = /^07[0-9]{9}?$/;

export const validateMobile = (value: string) =>
  new RegExp(MOBILE_REGEX).test(value);
